'use client';

import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from 'react';
import { ClerkProvider } from '@clerk/nextjs';
import { SonnerToaster } from '@extern/ui/sonner';
import { TooltipProvider } from '@extern/ui/tooltip';
import { NuqsAdapter } from 'nuqs/adapters/next/app';
import { ReactQueryProvider } from '@/infra/react-query/react-query-provider';
import { PageView } from '@/lib/analytics/page-view';
import { PostHogProvider } from '@/lib/analytics/posthog-provider';
import { LogRocketInit } from './log-rocket-init';
import { SegmentScript } from './segment-script';
import { TikTokPixelScript } from './tik-tok-pixel-script';
interface AppProvidersProps {
  children?: ReactNode;
}
export function AppProviders(t0) {
  const $ = _c(9);
  const {
    children
  } = t0;
  let t1;
  let t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <SonnerToaster />;
    t2 = <LogRocketInit />;
    t3 = <PageView />;
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
  } else {
    t1 = $[0];
    t2 = $[1];
    t3 = $[2];
  }
  let t4;
  if ($[3] !== children) {
    t4 = <ClerkProvider><PostHogProvider><ReactQueryProvider><NuqsAdapter><TooltipProvider>{children}{t1}{t2}{t3}</TooltipProvider></NuqsAdapter></ReactQueryProvider></PostHogProvider></ClerkProvider>;
    $[3] = children;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  let t6;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <SegmentScript />;
    t6 = <TikTokPixelScript />;
    $[5] = t5;
    $[6] = t6;
  } else {
    t5 = $[5];
    t6 = $[6];
  }
  let t7;
  if ($[7] !== t4) {
    t7 = <>{t4}{t5}{t6}</>;
    $[7] = t4;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  return t7;
}